/** Keep the native modal and focus trap alive until its exit animation finishes. */
export async function closeDialog(dialog: HTMLDialogElement | null) {
  if (!dialog?.open || dialog.classList.contains('dialog-closing')) return
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
    dialog.close()
    return
  }
  dialog.classList.add('dialog-closing')
  try {
    await Promise.allSettled(dialog.getAnimations().map(animation => animation.finished))
    if (dialog.isConnected && dialog.open) dialog.close()
  } finally {
    dialog.classList.remove('dialog-closing')
  }
}
